
  import { ComputedRef, Ref, computed, defineComponent, ref } from 'vue'

  import Timeline from '@/components/Dashboard/Timeline.vue'
  import UserCalendar from '@/components/Dashboard/UserCalendar/index.vue'
  import UserMonthStats from '@/components/Dashboard/UserMonthStats.vue'
  import UserRecords from '@/components/Dashboard/UserRecords/index.vue'
  import UserStatsCards from '@/components/Dashboard/UserStatsCards/index.vue'
  import { SPORTS_STORE, USER_STORE } from '@/store/constants'
  import { ISport } from '@/types/sports'
  import { IUserProfile } from '@/types/user'
  import { useStore } from '@/use/useStore'

  export default defineComponent({
    name: 'Dashboard',
    components: {
      Timeline,
      UserCalendar,
      UserMonthStats,
      UserRecords,
      UserStatsCards,
    },
    setup() {
      const store = useStore()
      const authUser: ComputedRef<IUserProfile> = computed(
        () => store.getters[USER_STORE.GETTERS.AUTH_USER_PROFILE]
      )
      const sports: ComputedRef<ISport[]> = computed(
        () => store.getters[SPORTS_STORE.GETTERS.SPORTS]
      )
      const isSelected: Ref<string> = ref('chart')

      function updateDisplayColumn(target: string) {
        isSelected.value = target
      }

      return { authUser, sports, isSelected, updateDisplayColumn }
    },
  })
